import { Fragment, useState } from "react";
import { CheckSquare } from "react-feather";
import { CloseButton, Toast, ToastBody } from "reactstrap";
import { Btn } from "../../../../AbstractElements";

const SuccessToast = () => {
  const [visible, setVisible] = useState(false);
  const toggle = () => setVisible(!visible);
  const handleClick = () => {
    setVisible(true);
    setTimeout(() => setVisible(false), 8000);
  };
  return (
    <Fragment>
      <Btn color="success" onClick={handleClick}>
        {"Success Toast"}
      </Btn>
      <div className="toast-container position-fixed top-0 end-0 p-3 toast-index toast-rtl">
        <Toast fade isOpen={visible}>
          <div className="d-flex justify-content-between align-items-center alert-light-success">
            <ToastBody>
              <CheckSquare className="close-search stroke-success" />
              {"Success: We've updated your info"}
            </ToastBody>
            <CloseButton className="me-2 m-auto" onClick={toggle} />
          </div>
        </Toast>
      </div>
    </Fragment>
  );
};

export default SuccessToast;
